import type { JobsFieldSet } from '@rogoag/airtable/crm';
import type LocalAtRecord from '../../../db/LocalAtRecordClass';
import { MissionState } from '../../../constants';

export interface MapAcresSummary {
  /** Acres of the unbroken run of finalized jobs from the start of the order. */
  mappedAcres: number;
  totalAcres: number;
  mappedJobs: number;
  totalJobs: number;
}

type MapAcresJob = Pick<LocalAtRecord<JobsFieldSet>, 'get'>;

/**
 * How far ahead of the operator the maps are ready: walking the unsampled jobs
 * by 'Order', sum their acres until the first job whose mission isn't
 * finalized. Sampled jobs are spent buffer and don't count; maps made past the
 * gap don't count either — the operator can't get to them yet.
 */
export function summarizeMapAcres(jobs: MapAcresJob[]): MapAcresSummary {
  const ordered = jobs
    .filter((job) => !job.get('Sample Date'))
    .sort((a, b) => (a.get('Order') ?? Number.POSITIVE_INFINITY) - (b.get('Order') ?? Number.POSITIVE_INFINITY));
  const firstUnmapped = ordered.findIndex((job) => job.get('Mission Status') !== MissionState._4_Mission_Finalized);
  const mapped = firstUnmapped === -1 ? ordered : ordered.slice(0, firstUnmapped);
  const sumAcres = (list: MapAcresJob[]) =>
    list.reduce((total, job) => total + (Number(job.get('Boundary Acres')) || 0), 0);

  return {
    mappedAcres: sumAcres(mapped),
    totalAcres: sumAcres(ordered),
    mappedJobs: mapped.length,
    totalJobs: ordered.length,
  };
}

export function formatMapAcres(summary: MapAcresSummary) {
  return `${Math.round(summary.mappedAcres)} ac mapped`;
}
